import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import { equipmentsQuery } from '../../api'
import { LoadingContainer } from '../../common/loaders/loadingcontainer'
import { localized } from '../../common/utils'

export function OrderedBenefits() {
	const { t } = useTranslation()
	const { data, error, isLoading } = useQuery(equipmentsQuery)

	const startKey = 'orderedBenefits_startDate'
	const endKey = 'orderedBenefits_endDate'

	const [startDate, setStartDate] = useState(() => {
		return (
			localStorage.getItem(startKey) ||
			new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().split('T')[0]
		)
	})

	const [endDate, setEndDate] = useState(() => {
		return (
			localStorage.getItem(endKey) ||
			new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().split('T')[0]
		)
	})

	const [filtered, setFiltered] = useState([])

	useEffect(() => {
		if (!data?.data) return

		const allowedTypes = ['Tietokone', 'Puhelin']

		const start = new Date(startDate)
		start.setUTCHours(0, 0, 0, 0)

		const end = new Date(endDate)
		end.setUTCHours(23, 59, 59, 999)

		const result = data.data
			.filter((x) => {
				const type = x.equipmentCodeItem?.description || x.equipmentCodeItem?.codeValue

				return allowedTypes.includes(type) && x.deliveryDate
			})
			.map((x) => {
				const date = new Date(x.deliveryDate)
				return {
					...x,
					_date: date,
				}
			})
			.filter((x) => {
				return x._date >= start && x._date <= end
			})
			.sort((a, b) => a._date - b._date)

		setFiltered(result)
	}, [data, startDate, endDate])

	const handleStartDateChange = (val) => {
		setStartDate(val)
		localStorage.setItem(startKey, val)
	}

	const handleEndDateChange = (val) => {
		setEndDate(val)
		localStorage.setItem(endKey, val)
	}

	if (isLoading) return <LoadingContainer />
	if (error) return error.message

	return (
		<div>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<h4 style={{ color: 'var(--heeros-blue)', margin: 0 }}>{t('OrderedBenefits', 'Tilatut luontoisedut')}</h4>

				<div style={{ display: 'flex', gap: '10px' }}>
					<input type="date" value={startDate} onChange={(e) => handleStartDateChange(e.target.value)} />

					<input type="date" value={endDate} onChange={(e) => handleEndDateChange(e.target.value)} />
				</div>
			</div>

			{filtered.length === 0 ? (
				<div style={{ marginTop: '15px' }}>({t('NoOrderedBenefits', 'Ei tilattuja luontoisetuja')})</div>
			) : (
				<div style={{ marginTop: '15px' }}>
					<Row className="fw-bold">
						<Col></Col>
						<Col></Col>
						<Col></Col>
					</Row>

					{filtered.map((x) => (
						<Row key={x.id}>
							<Col>{x.personName}</Col>
							<Col>{x.equipmentCodeItem?.description || x.equipmentCodeItem?.codeValue}</Col>
							<Col>{x._date.toLocaleDateString(localized.resolvedLanguage)}</Col>
						</Row>
					))}
				</div>
			)}
		</div>
	)
}
